import React from 'react'
import { Box, SxProps, Toolbar } from '@mui/material'

import BackButton from 'components/StepContainer/BackButton'
import { useSessionDispatch, useSessionState } from 'context/Session'

const styles: Record<string, SxProps> = {
  backButton: {
    position: 'absolute',
    bottom: -74,
    left: {
      xs: -10,
      md: 0,
    },
  },
  toolbar: {
    alignItem: 'flex-end',
    justifyContent: 'center',
    mb: '40px',
  },
  container: {
    position: 'relative',
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
}

export default function SubHeader(): JSX.Element {
  const { path, isSubmitted } = useSessionState()

  const [dispatch] = useSessionDispatch()

  const onClick = (): void => dispatch({ type: 'popStep' })

  const backButton = !(path.length === 0 || !!isSubmitted)

  return (
    <Box className="main-content-header" sx={styles.container}>
      <Toolbar sx={styles.toolbar}>
        {backButton && (
          <Box className="prev-page-btn-wrap" sx={styles.backButton}>
            <BackButton onClick={onClick} />
          </Box>
        )}
      </Toolbar>
    </Box>
  )
}
